import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";

import {
  userLoginReducer,
  userRegisterReducer,
  userDetailsReducer,
  userUpdateProfileReducer,
  userListReducer,
  userDeleteReducer,
  userUpdateReducer,
} from "./reducers/userReducers";

import {
  invoiceCreateReducer,
  invoiceDeleteReducer,
  invoiceDetailsReducer,
  invoiceListReducer,
  invoiceUpdateReducer,
  invoiceDataReducer,
  invoiceListTotalReducer,
} from "./reducers/invoiceReducers";

import {
  collegeCreateReducer,
  collegeDeleteReducer,
  collegeDetailsReducer,
  collegeListReducer,
  collegeUpdateReducer,
  collegeListTotalReducer,
} from "./reducers/collegeReducers";

import {
  affiliatePartnerCreateReducer,
  affiliatePartnerDeleteReducer,
  affiliatePartnerDetailsReducer,
  affiliatePartnerListReducer,
  affiliatePartnerUpdateReducer,
} from "./reducers/affiliatepartnerReducers";

import {
  partnerAgentCreateReducer,
  partnerAgentDeleteReducer,
  partnerAgentDetailsReducer,
  partnerAgentListReducer,
  partnerAgentUpdateReducer,
} from "./reducers/partnerAgentReducers";

import {
  getSubAgentVerifyStatusReducer,
  subAgentCreateReducer,
  subAgentDeleteReducer,
  subAgentDetailsReducer,
  subAgentListReducer,
  subAgentUpdateReducer,
  verifySubAgentStatusReducer,
} from "./reducers/subagentReducers";

import {
  invoiceTypeCreateReducer,
  invoiceTypeListReducer,
  invoiceTypeDetailsReducer,
  invoiceTypeDeleteReducer,
  invoiceTypeUpdateReducer,
} from "./reducers/invoiceTypeReducers";

import {
  contactListReducer,
  contactDetailsReducer,
} from "./reducers/contactReducers";

import { dealListReducer } from "./reducers/dealReducers";

import {
  applicationListReducer,
  invoiceApplicationListReducer,
} from "./reducers/applicationReducers";

import { countryListReducers } from "./reducers/countryReducers";

import { branchListReducers } from "./reducers/branchReducers";

import {
  notificationDetailReducer,
  notificationListReducer,
  notificationReadReducer,
} from "./reducers/notificationReducer";

import { TermListReducer } from "./reducers/TermListReducers";
import {
  documentCreateReducer,
  documentDeleteReducer,
  documentListReducer,
} from "./reducers/documentReducers";
import { documentTypeListReducer } from "./reducers/documentTypeReducers";
import { taskTypeListReducer } from "./reducers/taskTypeReducers";
import { taskCreateReducer } from "./reducers/taskReducers";
import { subAgentInvoiceCreateReducer, subAgentInvoiceDeleteReducer, subAgentInvoiceGetReducer, subAgentInvoiceListReducer, subAgentInvoiceUpdateReducer } from "./reducers/InvoiceSubAgentReducers";
import { subAgentInvoiceInternalCreateReducer, subAgentInvoiceInternalDeleteReducer, subAgentInvoiceInternalGetReducer, subAgentInvoiceInternalListReducer, subAgentInvoiceInternalUpdateReducer } from "./reducers/InvoiceSubAgentInternalReducers";
import { monthListReducer } from "./reducers/monthReducers";

const reducer = combineReducers({
  userLogin: userLoginReducer,
  userRegister: userRegisterReducer,
  userDetails: userDetailsReducer,
  userUpdateProfile: userUpdateProfileReducer,
  userList: userListReducer,
  userDelete: userDeleteReducer,
  userUpdate: userUpdateReducer,
  affiliatePartnerCreate: affiliatePartnerCreateReducer,
  affiliatePartnerDelete: affiliatePartnerDeleteReducer,
  affiliatePartnerDetails: affiliatePartnerDetailsReducer,
  affiliatePartnerList: affiliatePartnerListReducer,
  affiliatePartnerUpdate: affiliatePartnerUpdateReducer,
  collegeCreate: collegeCreateReducer,
  collegeDelete: collegeDeleteReducer,
  collegeDetails: collegeDetailsReducer,
  collegeList: collegeListReducer,
  collegeUpdate: collegeUpdateReducer,
  invoiceCreate: invoiceCreateReducer,
  invoiceDelete: invoiceDeleteReducer,
  invoiceDetails: invoiceDetailsReducer,
  invoiceData: invoiceDataReducer,
  invoiceList: invoiceListReducer,
  invoiceListTotal: invoiceListTotalReducer,
  invoiceUpdate: invoiceUpdateReducer,
  partnerAgentCreate: partnerAgentCreateReducer,
  partnerAgentDelete: partnerAgentDeleteReducer,
  partnerAgentDetails: partnerAgentDetailsReducer,
  partnerAgentList: partnerAgentListReducer,
  partnerAgentUpdate: partnerAgentUpdateReducer,
  getSubAgentVerifyStatusReducer,verifySubAgentStatusReducer,
  subAgentCreate: subAgentCreateReducer,
  subAgentDelete: subAgentDeleteReducer,
  subAgentDetails: subAgentDetailsReducer,
  subAgentList: subAgentListReducer,
  subAgentUpdate: subAgentUpdateReducer,
  invoiceTypeCreate: invoiceTypeCreateReducer,
  invoiceTypeDelete: invoiceTypeDeleteReducer,
  invoiceTypeDetails: invoiceTypeDetailsReducer,
  invoiceTypeList: invoiceTypeListReducer,
  invoiceTypeUpdate: invoiceTypeUpdateReducer,
  contactList: contactListReducer,
  contactDetails: contactDetailsReducer,
  dealList: dealListReducer,
  applicationList: applicationListReducer,
  invoiceApplicationList: invoiceApplicationListReducer,
  countryList: countryListReducers,
  collegeListTotal: collegeListTotalReducer,
  notificationList: notificationListReducer,
  notificationDetail: notificationDetailReducer,
  TermList: TermListReducer,
  branchList: branchListReducers,
  documentList: documentListReducer,
  documentCreate: documentCreateReducer,
  documentTypeList: documentTypeListReducer,
  documentDelete: documentDeleteReducer,
  taskTypeList: taskTypeListReducer,
  taskCreate: taskCreateReducer,
  subAgentInvoiceList: subAgentInvoiceListReducer,
  subAgentInvoiceCreate: subAgentInvoiceCreateReducer,
  subAgentInvoiceGet: subAgentInvoiceGetReducer,
  subAgentInvoiceUpdate: subAgentInvoiceUpdateReducer,
  subAgentInvoiceDelete: subAgentInvoiceDeleteReducer,
  subAgentInvoiceInternalList: subAgentInvoiceInternalListReducer,
  subAgentInvoiceInternalCreate: subAgentInvoiceInternalCreateReducer,
  subAgentInvoiceInternalGet: subAgentInvoiceInternalGetReducer,
  subAgentInvoiceInternalUpdate: subAgentInvoiceInternalUpdateReducer,
  subAgentInvoiceInternalDelete: subAgentInvoiceInternalDeleteReducer,
  monthList: monthListReducer,
  notificationRead: notificationReadReducer
});

const userInfoFromStorage = localStorage.getItem("accinf")
  ? JSON.parse(localStorage.getItem("accinf"))
  : null;

const expdtFromStorage = localStorage.getItem("acdt")
  ? JSON.parse(localStorage.getItem("acdt"))
  : null;

const initialState = {
  userLogin: { userInfo: userInfoFromStorage, expdt: expdtFromStorage },
};

const middleware = [thunk];

const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
